import React, { useEffect, useRef, useState } from 'react';
import styles from '../css/scanBarcodeCard.module.css';

export default function ScanBarcodeCard({ value = '', onChange }) {
  const inputRef = useRef(null);
  const [localValue, setLocalValue] = useState(value || '');
  const [error, setError] = useState('');
  const errorTimeoutRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select?.();
    }
  }, []);

  useEffect(() => {
    // If parent provides a value, keep local state in sync
    if (typeof value === 'string' && value !== localValue) {
      setLocalValue(value);
    }
  }, [value]);

  useEffect(() => () => {
    if (errorTimeoutRef.current) {
      clearTimeout(errorTimeoutRef.current);
    }
  }, []);

  return (
    <div className={styles.cardWrapper}>
      <div className={styles.card}>
        <div className={styles.iconCircle}>
          <span className={styles.iconGlyph}>◫</span>
        </div>
        <h2 className={styles.title}>Ready to Scan Barcode</h2>
        <p className={styles.subtitle}>
          Point your scanner at the item's barcode to automatically add it to the
          inventory
        </p>
        <div className={styles.inputShell}>
          <input
            type="text"
            className={styles.input}
            placeholder="Scan or enter barcode here..."
            value={localValue}
            onChange={e => {
              // Enforce numeric-only and max 12 digits
              const digits = String(e.target.value || '').replace(/[^0-9]/g, '');

              if (digits.length > 12) {
                setLocalValue('');
                setError('Barcode must be exactly 12 digits');

                if (errorTimeoutRef.current) {
                  clearTimeout(errorTimeoutRef.current);
                }
                errorTimeoutRef.current = setTimeout(() => {
                  setError('');
                  if (inputRef.current) {
                    inputRef.current.focus();
                    inputRef.current.select?.();
                  }
                }, 3000);

                onChange?.('');
                if (inputRef.current) {
                  inputRef.current.focus();
                  inputRef.current.select?.();
                }
                return;
              }

              setLocalValue(digits);
              onChange?.(digits);
            }}
            ref={inputRef}
          />
          {error && (
            <div className={styles.errorText}>{error}</div>
          )}
        </div>
      </div>
    </div>
  );
}
